import React, { memo } from "react";
import {
  Divider,
  Drawer,
  DrawerProps,
  SvgIconTypeMap,
  Hidden,
} from "@material-ui/core";
import useDashboardDrawer from "./index.hooks";
import { Link } from "react-router-dom";
import AppLogo from "assets/images/banner_image.png";
import { SectionListItem } from "components";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";

type DashboardDrawerProps = {
  sectionSlug: string;
  isDrawerOpen: boolean;
  handleDrawerToggle: (drawerOpen: boolean) => void;
  sections: {
    slug: string;
    label: string;
    icon: OverridableComponent<SvgIconTypeMap>;
    component: any;
  }[];
} & DrawerProps;

const DashboardDrawer: React.FC<DashboardDrawerProps> = ({
  isDrawerOpen,
  handleDrawerToggle,
  sectionSlug,
  sections,
  ...props
}: DashboardDrawerProps) => {
  const { classes, styles, drawerModalProps, t } = useDashboardDrawer();

  const drawerContent = (
    <>
      <Link to="/merchants">
        <img src={AppLogo} alt={t("Gestione")} className={styles.headerImg} />
      </Link>
      <Divider light variant="middle" classes={classes.divider} />
      <div className={styles.listContainer}>
        {sections.map((sect) => (
          <SectionListItem
            active={sect.slug === sectionSlug}
            key={sect.slug}
            section={sect}
          />
        ))}
      </div>
    </>
  );

  return (
    <div>
      <Hidden smUp implementation="css">
        <Drawer
          variant="temporary"
          open={isDrawerOpen}
          onClose={handleDrawerToggle}
          classes={classes.drawer}
          ModalProps={drawerModalProps}
        >
          {drawerContent}
        </Drawer>
      </Hidden>
      <Hidden xsDown implementation="css">
        <Drawer {...props} variant="persistent" open classes={classes.drawer}>
          {drawerContent}
        </Drawer>
      </Hidden>
    </div>
  );
};

export default memo(DashboardDrawer);
